/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IMetricType {
  Cals = 'cals',
  Distance = 'distance',
  ElevationGain = 'elevation-gain',
  Duration = 'duration',
  Pace = 'pace',
  AvgWatts = 'avg-watts',
  AverageSpeed = 'average-speed',
  Average500MSplit = 'average-500M-split',
  WorkoutsCount = 'workouts-count',
}
